import React, { useState, useEffect } from "react";
import { useParams, Link, Outlet } from "react-router-dom";
import useApi from "../../hooks/useApi";
import Accordion from "react-bootstrap/Accordion";
import ProductRequirementCard from "./ProductRequirementCard";
import ProductClaimRequirementCard from "./ProductClaimRequirementCard";
import { NavigateBackButton } from "../../widgets";

const ProductView = () => {
  const [product, setProduct] = useState({});
  const { id } = useParams();

  const { api, abortSignal, auth } = useApi();
  useEffect(() => {
    const callApi = async () => {
      try {
        const response = await api.read(`/products/${id}`);
        if (response.success) setProduct(response.data);
      } catch (error) {
        // console.error(error);
      }
    };
    callApi();

    const abortApiCall = () => abortSignal && abortSignal.abort;
    return abortApiCall;
  }, [id, auth]);

  return (
    <section id="content" className="content">
      <div className="content__header content__boxed">
        <div className="content__wrap">
          {/* <!-- Breadcrumb --> */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/desktop">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/products">Products</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {product?.name || id}
              </li>
            </ol>
          </nav>
          {/* <!-- END : Breadcrumb --> */}

          <h1 className="page-title mb-0 mt-2">
            {product?.name || "Product detail"}
          </h1>

          <p className="lead">Detail view of Product</p>
        </div>
      </div>

      <div className="content__boxed">
        <div className="content__wrap">
          <div className="row">
            <div className="col-xxl-9 col-xl-8 col-lg-7 col-sm-12">
              <div className="d-md-flex align-items-baseline mt-3">
                <div className="d-flex align-items-center gap-1 text-nowrap ms-auto mb-3">
                  <NavigateBackButton />
                </div>
              </div>
              {<Outlet />}
              <Accordion defaultActiveKey={["0"]} className="my-3">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Policy Requirements</Accordion.Header>
                  <Accordion.Body>
                    <ProductRequirementCard />
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Claims Requirements</Accordion.Header>
                  <Accordion.Body>
                    <ProductClaimRequirementCard />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            <div className="col-xxl-3 col-xl-4 col-lg-5 col-sm-12">
              {/* <!-- User widget with background color --> */}
              <div className="card mb-3">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <a
                      href="#"
                      className="d-inline-block h5 btn-link text-truncate mb-2"
                    >
                      {product?.name}
                    </a>
                    <Link
                      to="edit"
                      className="btn btn-xs btn-hover btn-light text-decoration-none p-1"
                    >
                      <i className="demo-psi-pen-5 fs-5"></i>
                    </Link>
                  </div>
                  <p className="text-break">{product?.info}</p>
                  <p className="text-break text-primary">
                    {product?.Company?.name}
                  </p>
                  <div>
                    <small className="text-primary">Policy Type</small>
                    <p className="text-break fw-bold fs-4">
                      {product?.PolicyType?.name}
                    </p>
                  </div>
                  <div>
                    <small className="text-primary">Commission Rate</small>
                    <p className="fw-bold fs-4">{product?.commissionRate}</p>
                  </div>
                </div>
              </div>

              {/* <!-- END : User widget with background color --> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductView;
